import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import { SplitText } from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(ScrollTrigger, SplitText);
import { enableScroll, disableScroll } from "../common/ScrollDisabler";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    //
    this.FX = {
      textA: new SplitText(this.ref.textA[0].querySelector("p"), {
        type: "words",
        wordsClass: "tw-overflow-hidden tw-mt-[-5px]",
      }),
      textAChildren: new SplitText(this.ref.textA[0].querySelector("p"), {
        type: "words",
      }),
      textB: new SplitText(this.ref.textB[0], {
        type: "words",
        wordsClass: "tw-overflow-hidden tw-mt-[-5px]",
      }),
      textBChildren: new SplitText(this.ref.textB[0], { type: "words" }),
    };
    // Fns
    this.makeSticky();
    this._fx();
  }

  _fx() {
    this.prepare();
    this.animate();
  }

  animate() {
    this.animation = gsap.timeline({ delay: 0.5 });

    let leS = {
      from: { y: "100%" },
      to: { y: 0, ease: "quint.inOut", duration: 1.5 },
    };
    if (Env.mobileCSS) {
      leS = {
        from: { x: "100%" },
        to: { x: 0, ease: "quint.inOut", duration: 1.5 },
      };
    }

    this.animation
      .add([
        gsap.fromTo(
          this.ref.progress,
          {
            transformOrigin: "left top",
            scaleX: 0,
          },
          {
            scaleX: 1,
            ease: "quint.inOut",
            duration: 1.5,
          }
        ),
        gsap.fromTo(this.ref.leS, leS.from, leS.to),
      ])
      .add(() => Env.$html.classList.add("ui--isReady"))
      .add([
        gsap.fromTo(
          this.FX.textAChildren.words,
          {
            y: 20,
          },
          {
            y: 0,
            ease: "quint.out",
            duration: 0.7,
            stagger: 0.03,
          }
        ),
        gsap.fromTo(
          this.FX.textBChildren.words,
          {
            y: 20,
          },
          {
            y: 0,
            ease: "quint.out",
            duration: 0.7,
            stagger: 0.03,
            delay: 0.2,
          }
        ),
      ]);
  }

  makeSticky() {
    this.sticky = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top -45%",
      pin: true,
      pinSpacing: true,
      invalidateOnRefresh: true,
    });
  }

  prepare() {
    gsap.set(this.ref.cache, { autoAlpha: 0 });
  }

  unmount() {
    this.sticky.kill();
  }
}
